import { ExamSubject } from 'generated/graphql'

interface SubjectTabType {
  id: string
  label: string
}

export const TAB_LIST: SubjectTabType[] = [
  { id: ExamSubject.MATH, label: '수리 영역' },
  { id: ExamSubject.REASONING, label: '추리 영역' },
]
